import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  sub?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  title,
  sub,
  align = 'center'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-3xl ${alignment}`} data-id="element-283" data-mp="3jzx3xyruk6ov">
      <h2 className="font-display text-[38px] font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-284" data-mp="3k0p0bbt9q8g7">
        {title}
      </h2>
      {sub && <p className="mt-4 text-lg font-medium text-mist sm:text-xl" data-id="element-285" data-mp="gjq1fvl64fho">{sub}</p>}
    </div>;
}